// Get all table elements
const tables = document.querySelectorAll('.main table');

// create wrapper container
const wrapper = document.createElement('div');
wrapper.classList.add('table-container');

// insert wrapper before el in the DOM tree
tables.forEach((table) => {
  table.parentNode.insertBefore(wrapper, table);
  wrapper.appendChild(table);
});
